import styled from 'styled-components';

export const Main = styled.div`
   min-width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   .action {
      position: relative;
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      margin-bottom: 11px;

      &::after {
         content: '';
         position: absolute;
         left: 0;
         bottom: 0;
         width: 100%;
         height: 0.5px;
         background-color: rgb(220, 220, 220);
      }
      .btn1 {
         margin-top: 3px;
         .line {
            margin-bottom: 0;
            &::after { display: none; }
         }
      }
      .download { margin-left: 7.5px; }
   } 
   .select {
      margin-bottom: 10px;
      h4 { width: 65px; }
   }
   .textInput {
      margin-bottom: 10px;
      h4 { width: 80px; }

      &:last-of-type {
         margin-bottom: 0;
      }
   }
   textarea { 
      padding: 7.5px;
      font-size: 15px;
      min-height: 100px;
   }
   .switch { 
      margin-top: 7.5px;
      margin-bottom: 10px;
   }
   .status {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: rgb(245, 245, 245);
      border: 1px solid rgb(220, 220, 220);
      border-radius: 10px;
      padding: 0 15px;
      font-size: 15px;
      margin-top: 7.5px;
      height: 40px;

      > div {
         display: flex;
         align-items: center;
         width: 150px;

         span:first-of-type {
            width: 10px;
            height: 10px;
            background-color: red;
            margin-right: 7.5px;
            border-radius: 2px;
            box-shadow: 0 0 3px red;

            &.green {
               background-color: #339966;
               box-shadow: 0 0 3px #339966;
            }
         }
         span:last-of-type {
            opacity: 0.85;
         }
      }
      > span { opacity: 0.85; }
   }
   .filesEdit {
      top: 17px !important;
      right: calc(100% + 22px) !important;
      height: auto !important;
      max-height: 200px;

      .checkbox {
         height: auto !important;
         max-height: 186px;
      }
   }
   .autopilot {
      margin-top: 20px;

      &+p {
         width: 300px;
         margin: auto;
         text-align: center;
         font-size: 14px;
         color: #ff0000;
         opacity: 0.75;
         line-height: 1.3;
      }
   }
`;